module.exports = __webpack_public_path__ + "img/icon-business-receive-04.svg";